export const INFO_MESSAGE = `
We will send you an email with a link to reset your password if provided email was found in our system.
`
